import SkeletonCM from "components/shared/Skeleton";
import { StyledSlideProductDiv } from "./Loading.style";

function SkeletonProductCM(props) {
  return (
    <StyledSlideProductDiv>
      <SkeletonCM Height={200} />
      <div style={{ textAlign: "center", marginBottom: "6px" }}>
        <SkeletonCM
          Circle
          Inline
          Width={20}
          Height={20}
          Count={5}
          mLeft={10}
          mTop={10}
        />
      </div>
      <SkeletonCM Height={30} />
      <SkeletonCM Height={30} mTop={40} />
    </StyledSlideProductDiv>
  );
}

export default SkeletonProductCM;
